#import "../../../../common/graphql/EntityDocumentsFields.graphql"

query UserProfile($id: UUID!) {
  userProfile(id: $id) {
    id
    _isApproved
     _signinInfo {
      isUserAdministrator
      isProjectSupervisor
      profileIconState
      profileIconType
      isActivateAllowed
      isDeactivateAllowed
    }
    _activeApprovalCount
    _lastUsedDate
    __typename
    _urgencyLevel
    _rowTimestamp
    name
    description
    emailAccount
    isNewProjectIncluded
    departmentOccupationTemplateId
    
    _isUserSignatureUpdatable
    _isUserSignatureRequired
    roleId
    role {
      id
      name
    }
     departmentOccupationTemplate {
        name
        description
        isTemplateControlled
        departmentId
    }
    signatureDocument {
      id
      _downloadLink
    }
    userRankTypeId
    userRankType {
      userRank
      id
    }
    secureRowLevelId
    secureRowLevel {
      id
      securityLevel
    }
    invited
    _invitationStatusTypeId
    inviteStatusType {
        statusType
      }
    userOccupationTitleId
      userOccupationTitle {
        userOccupationTitle
        userRankTypeId
      }
    departmentId
      department {
        name
      }
    departmentGroupId
      departmentGroup {
        name
      }
    dataAccessPolicyId
     dataAccessPolicy {
        name
      }
    userGroupId
          userGroup {
        name
      }
    accessGroupId
     accessGroup {
        name
        _isStagedApprovalRequest
        _isUpdatable
        _isDeletable
        _isApproved
        _isApprovalRevocable
      }
    tagGroupId
     tagGroup {
        name
      }
    communicationGroupId
     communicationGroup {
        name
      }
    isSigninAllowed
    _isApprovalRevocable
    _isStagedApprovalRequest
    _isUserApprovalTreeViewer
    _isAuthenticatedUser
    _isProfileValidated
    _isStagedToInvite
    _statusTypeId
    statusType {
      statusType
      approvalState
    }
    isDraft
    _isDeletable
    _rowTimestamp
    _isUpdatable
    userApprovalGrants(
      orderBy: APPROVAL_TYPE_BY_APPROVAL_TYPE_ID__APPROVAL_TYPE_ASC
    ) {
      nodes {
        id
        _rowTimestamp
        approvalTypeId
        isApprover
        isRequester
        isAddingNonApproversAllowed
        isApprovalRevokingEnabled
        isApprovalTreeViewerAllowed
        isAutoApproveEnabled
        isEnMasseApprovalsEnabled
        isExtendedApprover
        isLowerTreeLevelBypassEnabled
        isSelfApproveEnabled
        _isDeletable
      }
    }
    entityDocumentsByEntityId(
      orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
    ) {
      nodes {
        ...EntityDocumentsFields
      }
    }
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
       edges {
          node {
            id
          }
        }
      nodes {
        id
        _createdByUserName
        _createdDate
        noteComment
        isShared
        _isUpdatable
        _rowTimestamp
      }
    }
    userProfileHistoriesByEntityId {
      nodes {
        tenantUserName
        pointInTimeDate
        crudOperation
      }
    }
    approvalHistoriesByEntityId(orderBy: REQUESTED_DATE_DESC) {
      nodes {
        id
        requesterName
        requestedDate
        amount1
        currencyIsoCode
        isApprovalTreeViewerAllowed
        iconType {
          iconType
          iconState
        }
        statusType {
          statusType
        }
      }
    }
    approvalHistorySignaturesByEntityId(
      orderBy: SORT_ORDER_ASC
      filter: {
        not: {
          isApproved: { equalTo: false }
          isRejected: { equalTo: false }
          isRequested: { equalTo: false }
        }
      }
    ) {
      nodes {
        id
        additionalInformation
        digitalSignature
        actionDate
        isApproved
        isRejected
        isRequested
        userName
        entityDocumentId
        userSignatureDocument {
          id
          _downloadLink
          fileIndexInformation
          fileReference
          iconType
        }
      }
    }
  }
}
